export default __webpack_public_path__ + "static/media/addFriend.f0efbb61.svg";